export enum FeatureName {
  MAINTENANCE = 'maintenance',
  RENTALS = 'rentals',
  CAMPAIGN = 'campaign',
  DCL_CONTROLLER_V2 = 'dcl-controller-v2',
  DEPLOY_WORLDS = 'deploy-worlds',
  SCENE_TEMPLATES = 'scene-templates',
  HANDS_CATEGORY = 'hands-category',
  WEB_EDITOR = 'web-editor',
  PUBLISH_SMART_WEARABLES = 'publish-smart-wearables'
}
